import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import {Site, SiteTariffs, Utility} from "../../../../domain/cloud-topology";
import {Subject} from "rxjs";
import {SiteService} from "../../../../services/site/site.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ToastService} from "../../../../services/toast-service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {takeUntil} from "rxjs/operators";

@Component({
    selector: 'app-site-utilities',
    templateUrl: './site-utilities.component.html',
    standalone: false
})
export class SiteUtilitiesComponent implements OnChanges, OnDestroy {
  @Input() site: Site;
  @Input() utility: Utility;
  @Input() siteTariffs: SiteTariffs;
  @Output() isUtilityFormDirty: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() utilityChange = new EventEmitter<Utility>();
  @Output() siteTariffsChange = new EventEmitter<SiteTariffs>();

  private subject$: Subject<void>;
  utilityForm : FormGroup;
  utilities: Utility[];

  constructor(private siteService: SiteService,
              private snackBar: MatSnackBar) { }

  ngOnChanges() {
    this.subject$ = new Subject<void>();
    this.siteService.getAllUtilities().pipe(takeUntil(this.subject$)).subscribe(utilities => {
      this.utilities = utilities;
    });

    this.utilityForm = new FormGroup({
      utility: new FormControl( (this.utility?.shortName != null) ? this.utility?.shortName : '', Validators.required)
    });
  }

  ngOnDestroy(): void {
    this.subject$.next();
    this.subject$.complete();
  }

  save(): void {
    if (window.confirm(`Are you sure you want to update utility for ${this.site.name}? This will clear the tariffs configured for this site!`)) {
      if (this.utilityForm.get('utility').value !== this.utility) {
          this.siteService.deleteSiteTariffs(this.site.id).subscribe( () => {
            this.siteService.getSiteTariffs(this.site.id).pipe(takeUntil(this.subject$)).subscribe(siteTariffs => {
              this.siteTariffs = siteTariffs;
              this.siteTariffsChange.emit(this.siteTariffs);
            });
        });
      }

      this.siteService.putUtility(this.site.id, this.utilityForm.get('utility').value).subscribe(() => {
        this.isUtilityFormDirty.emit(false);
        this.siteService.getUtility(this.site.id).subscribe(response => {
          this.utility = response;
          this.utilityChange.emit(this.utility);
        })
        this.snackBar.open(`${this.site.name} utility has been updated.`, "Close",{
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "bottom"
        });

      }, () => {
        this.snackBar.open('Error saving utility for site.', "Close",{
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "bottom"
        });

      });
    }
  }

  cancel(): void {
    if (window.confirm(`Are you sure you want to discard utility changes?`)) {
      this.isUtilityFormDirty.emit(false);
      this.utilityForm.reset({
        utility: this.utility.shortName,
      });
    }
  }

  setDirtyForm() {
    this.isUtilityFormDirty.emit(true);
  }

}
